module.exports = __webpack_public_path__ + "img/ic_people_black_24px.svg";